import { GetSessionDefaultsResp } from 'types/api/response/get-session-defaults-resp'

import { api } from './api'

export const getSessionDefaults = () =>
  api.get<GetSessionDefaultsResp>('/configurations/session_defaults')
